import React from 'react';
import { Trans } from '@lingui/macro';

import { LegendContainer, LegendItem, LegendDot } from './style';
import { TYPE_COLORS } from './graphPalette';

const LEGEND_ITEMS = [
  { label: <Trans>Task</Trans>, dotColor: TYPE_COLORS.task },
  { label: <Trans>Choice</Trans>, dotColor: TYPE_COLORS.choice },
  { label: <Trans>Parallel</Trans>, dotColor: TYPE_COLORS.parallel },
  { label: <Trans>Map</Trans>, dotColor: TYPE_COLORS.map },
  { label: <Trans>Pass</Trans>, dotColor: TYPE_COLORS.pass },
  { label: <Trans>Wait</Trans>, dotColor: TYPE_COLORS.wait },
  { label: <Trans>Succeed</Trans>, dotColor: TYPE_COLORS.succeed },
  { label: <Trans>Fail</Trans>, dotColor: TYPE_COLORS.fail },
];

export default function CommandsLegend() {
  return (
    <LegendContainer>
      {LEGEND_ITEMS.map(({ label, dotColor }) => (
        <LegendItem key={dotColor}>
          <LegendDot dotColor={dotColor} />
          {label}
        </LegendItem>
      ))}
    </LegendContainer>
  );
}
